(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[665],{

/***/ 1743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CrimePage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
;// CONCATENATED MODULE: ./components/crime/CaseLists.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var _ref =  true ? {
  name: "u7ytkp",
  styles: "margin-right:0.5rem"
} : 0;

var _ref2 =  true ? {
  name: "amedx",
  styles: "color:#6f6f6f;text-decoration:none;&:hover{font-weight:500;}"
} : 0;

var _ref3 =  true ? {
  name: "zs3saj",
  styles: "margin:5px 0;padding-left:2rem;text-indent:-1rem"
} : 0;

const CaseLists = ({
  data
}) => {
  const title = cases => {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: cases.map(ele => {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          css: _ref3,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
            css: _ref2,
            href: "https://legalengine.co.kr/cases/".concat(ele.auto_hash),
            target: "_blank",
            rel: "noreferrer",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              css: _ref,
              children: ele.title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_image["default"], {
              src: "/crime/new_tab.png",
              width: 15,
              height: 15
            })]
          })
        }, ele.auto_hash);
      })
    });
  };

  const mobileCss = "width: 100%; font-size:16px;";

  const render = data => {
    const {
      output
    } = data;

    if (output.length === 0) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;width:80%;min-height:200px;border:1px solid #c4c4c4;border-radius:5px;color:#6f6f6f;font-size:18px;padding:1rem 2rem;@media (max-width: 992px){", mobileCss, ";}" + ( true ? "" : 0),  true ? "" : 0),
        children: "\uD604\uC7AC \uAC80\uC0C9\uD55C \uBB34\uC8C4 \uD310\uB840\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
      });
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-flow:column nowrap;justify-content:flex-start;align-items:flex-start;width:80%;min-height:200px;border:1px solid #c4c4c4;border-radius:5px;color:#6f6f6f;font-size:18px;padding:1rem 2rem;@media (max-width: 992px){", mobileCss, ";}" + ( true ? "" : 0),  true ? "" : 0),
      children: output.map(ele => {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("border:2px solid #d93729;box-sizing:border-box;border-radius:17px;padding:3px 15px;color:#d93729;font-size:18px;font-weight:700;margin:1rem 0;@media (max-width: 992px){", mobileCss, " width:fit-content;}" + ( true ? "" : 0),  true ? "" : 0),
            children: ele.value
          }), title(ele.cases)]
        }, ele.value);
      })
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("font-size:22px;font-weight:700;color:#000000;width:80%;display:flex;flex-flow:row nowrap;justify-content:flex-start;align-items:center;gap:1rem;@media (max-width: 992px){", mobileCss, ";}" + ( true ? "" : 0),  true ? "" : 0),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_image["default"], {
        src: "/crime/crime_3.png",
        layout: "fixed",
        alt: 'Legal Engine',
        width: 25,
        height: 25
      }), "\uBB34\uC8C4 \uD310\uB840"]
    }), render(data)]
  });
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./utils/WindowDemension.ts

const WindowDimension = () => {
  const {
    0: windowSize,
    1: setWindowSize
  } = (0,react.useState)({
    width: 0,
    height: 0
  });
  (0,react.useEffect)(() => {
    if (true) {
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      };

      window.addEventListener('resize', handleResize);
      handleResize();
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);
  return windowSize;
};
;// CONCATENATED MODULE: ./utils/linkshare.ts
const copyClipboard = async () => {
  const url = window.location.href;

  try {
    await navigator.clipboard.writeText(url);
  } catch (error) {
    console.error(error);
  }
};
/* templateId 카카오 sdk 확인  */

const sendKakaoLinkShare = linkData => {
  const {
    title,
    description,
    path,
    email
  } = linkData;

  if (window.Kakao) {
    const Kakao = window.Kakao;
    Kakao.Link.sendCustom({
      templateId: 67397,
      templateArgs: {
        title: "".concat(title),
        description: "".concat(description),
        path: "".concat(path)
      },
      serverCallbackArgs: "{\n          \"path\": \"".concat(path, "\",\n          \"email\": \"").concat(email, "\"\n        }")
    });
  }
};
;// CONCATENATED MODULE: ./components/crime/CrimeResult.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function CrimeResult_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










const mobileCss = "width: 100%; font-size:16px;";
const renderCssProps = "display: flex;\njustify-content: center;\nalign-items: center;\nflex-flow: row wrap;\nwidth: 80%;\nmin-height: 5rem;\nborder: 1px solid #c4c4c4;\nborder-radius: 5px;\ncolor: #6f6f6f;\nfont-size: 18px;\ngap: 1rem;\n@media (max-width: 992px) {\n  ".concat(mobileCss, "\n}\n");

var CrimeResult_ref =  true ? {
  name: "91xa6t",
  styles: "@media (max-width: 992px){display:none;}"
} : 0;

var CrimeResult_ref2 =  true ? {
  name: "mvaqzx",
  styles: "display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;gap:0.5rem;cursor:pointer"
} : 0;

var CrimeResult_ref3 =  true ? {
  name: "91xa6t",
  styles: "@media (max-width: 992px){display:none;}"
} : 0;

var _ref4 =  true ? {
  name: "mvaqzx",
  styles: "display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;gap:0.5rem;cursor:pointer"
} : 0;

var _ref5 =  true ? {
  name: "80768x",
  styles: "display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;gap:0.75rem;font-size:18px;font-weight:700"
} : 0;

var _ref6 =  true ? {
  name: "k94p2q",
  styles: "display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;gap:1rem"
} : 0;

const CrimeResult = ({
  data,
  userEmail
}) => {
  const {
    0: copyText,
    1: setCopyText
  } = (0,react.useState)({
    clipboard: 'URL 복사',
    kakao: '카카오톡'
  });
  const router = (0,next_router.useRouter)();
  const {
    width
  } = WindowDimension();

  const kakaoData = () => {
    const asPath = router.asPath;
    const email = userEmail || '';
    let input = '';

    if (data.input.length === 0) {
      input = '문제가 된 상황에 맞춰 무죄 판결문을 찾아드립니다.';
    } else {
      input = "\uC0AC\uAC74 \uB0B4\uC6A9: \"".concat(data.input, "\"");
    }

    const result = {
      title: '무슨 범죄인지 찾아드립니다',
      description: input,
      path: asPath,
      email: email
    };
    return result;
  };

  const handleCopy = async () => {
    await copyClipboard();
    {
      width < 992 ? alert('복사되었습니다.') : null;
    }
    setCopyText(_objectSpread(_objectSpread({}, copyText), {}, {
      clipboard: '복사 완료'
    }));
    setTimeout(() => {
      setCopyText(_objectSpread(_objectSpread({}, copyText), {}, {
        clipboard: 'URL 복사'
      }));
    }, 3000);
  };

  const resultTag = output => {
    const result = output.map(ele => {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("border:2px solid #d93729;box-sizing:border-box;border-radius:17px;padding:3px 15px;color:#d93729;font-size:18px;font-weight:700;@media (max-width: 992px){", mobileCss, " width:fit-content;margin:0.5rem 0;}" + ( true ? "" : 0),  true ? "" : 0),
          children: ele.value
        })
      }, ele.value);
    });
    return result;
  };

  const render = data => {
    const {
      output
    } = data;

    if (output.length === 0) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(renderCssProps, ";" + ( true ? "" : 0),  true ? "" : 0),
        children: "\uD604\uC7AC \uAC80\uC0C9\uD55C \uC8C4\uBA85\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
      });
    }

    const tags = resultTag(output);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(renderCssProps, " justify-content:flex-start;padding:1rem;" + ( true ? "" : 0),  true ? "" : 0),
      children: tags
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("font-size:22px;font-weight:700;color:#000000;width:80%;display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:space-between;gap:1rem;@media (max-width: 992px){", mobileCss, ";}" + ( true ? "" : 0),  true ? "" : 0),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: _ref6,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_image["default"], {
          src: "/crime/crime_2.png",
          layout: "fixed",
          alt: 'Legal Engine',
          width: 25,
          height: 25
        }), "AI \uAC80\uC0C9 \uACB0\uACFC"]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: _ref5,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: _ref4,
          onClick: handleCopy,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_image["default"], {
            src: "/social/link.png",
            layout: "fixed",
            alt: 'link',
            width: 32,
            height: 32
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: CrimeResult_ref3,
            children: copyText.clipboard
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: CrimeResult_ref2,
          onClick: () => sendKakaoLinkShare(kakaoData()),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_image["default"], {
            src: "/social/kakao_navy.png",
            objectFit: "fill",
            alt: 'kakaolink',
            width: 32,
            height: 32
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: CrimeResult_ref,
            children: copyText.kakao
          })]
        })]
      })]
    }), render(data), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("width:80%;padding-left:0.75rem;text-indent:-1rem;color:#9b9b9b;font-size:18px;@media (max-width: 992px){", mobileCss, ";}" + ( true ? "" : 0),  true ? "" : 0),
      children: ["\u203B \uB9AC\uAC78\uC5D4\uC9C4\uC740 \uD310\uACB0\uBB38 \uAC80\uC0C9 \uC11C\uBE44\uC2A4\uB9CC \uC81C\uACF5\uD560 \uBFD0, \uBC95\uB960\uC0C1\uB2F4\uC774\uB098 \uC608\uCE21 \uB4F1 \uBC95\uB960\uC0AC\uBB34\uB97C \uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uAC80\uC0C9 \uACB0\uACFC\uB294 \uB2E8\uC21C \uCC38\uACE0\uC6A9\uC73C\uB85C\uB9CC \uC0AC\uC6A9\uD558\uC2DC\uACE0, \uC815\uD655\uD55C \uC0C1\uB2F4\uC740 \uBCC0\uD638\uC0AC\uC5D0 \uBB38\uC758\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4."]
    })]
  });
};
;// CONCATENATED MODULE: ./components/crime/CrimeSearchBar.tsx
function CrimeSearchBar_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var CrimeSearchBar_ref =  true ? {
  name: "19owft3",
  styles: "color:#6f6f6f;font-size:20px;font-weight:400;@media (max-width: 992px){font-size:16px;}"
} : 0;

var CrimeSearchBar_ref2 =  true ? {
  name: "1mys3sh",
  styles: "margin-left:1rem"
} : 0;

var CrimeSearchBar_ref3 =  true ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : 0;

// defaultValue가 주어지는 경우 value는 무시되고 uncontrolled component가 됨. 내부적으로 state 관리가 이루어짐.
const CrimeSearchBar = ({
  cssProps,
  placeholder = '',
  queryText,
  setQueryText
}) => {
  const maxNumberOfWords = 400;
  const mobileCss = "width: 100%; font-size:16px;";

  const countWord = queryText => {
    const result = queryText.split(' ').length;
    return result;
  };

  const onChange = ev => {
    const {
      value
    } = ev.target;

    if (value.split(' ').length <= maxNumberOfWords) {
      setQueryText(value);
    } else {
      const limitValue = value.split(' ').slice(0, maxNumberOfWords).join(' ');
      setQueryText(limitValue);
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("font-size:22px;font-weight:700;color:#000000;width:80%;display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;gap:1rem;@media (max-width: 992px){", mobileCss, ";}" + ( true ? "" : 0),  true ? "" : 0),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: CrimeSearchBar_ref3,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_image["default"], {
          src: "/crime/crime_1.png",
          layout: "fixed",
          alt: 'Legal Engine',
          width: 25,
          height: 25
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          css: CrimeSearchBar_ref2,
          children: "\uBB38\uC81C\uAC00 \uB41C \uC0C1\uD669\uC744 \uC54C\uB824\uC8FC\uC138\uC694"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: CrimeSearchBar_ref,
        children: "".concat(queryText ? countWord(queryText) : 0, " / 400 \uB2E8\uC5B4")
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("width:80%;padding-left:0.75rem;margin:-1rem 0;text-indent:-1rem;color:#9b9b9b;font-size:18px;@media (max-width: 992px){", mobileCss, ";}" + ( true ? "" : 0),  true ? "" : 0),
      children: "\u203B \uC5B8\uC81C/\uC5B4\uB514\uC11C/\uB204\uAD6C\uC640/\uBB34\uC5C7\uC744 \uD588\uB294\uC9C0 \uAD6C\uCCB4\uC801\uC73C\uB85C \uC785\uB825\uD558\uC2DC\uBA74 \uB354\uC6B1 \uC815\uD655\uD55C \uACB0\uACFC\uAC00 \uB098\uC635\uB2C8\uB2E4."
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("textarea", {
      placeholder: placeholder,
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-flow:row nowrap;justify-content:center;font-size:18px;font-weight:400;padding:30px;align-items:center;width:80%;height:15rem;resize:none;font-family:Noto Sans KR,Roboto,sans-serif;line-height:1.5;", cssProps, ";::placeholder{font-size:18px;font-weight:400;color:#6f6f6f;}&:focus{outline:none;}@media (max-width: 992px){", mobileCss, ";}" + ( true ? "" : 0),  true ? "" : 0),
      value: queryText,
      onChange: ev => onChange(ev)
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(1496);
;// CONCATENATED MODULE: ./components/CustomLink.tsx


const _excluded = (/* unused pure expression or super */ null && (["to", "linkAs", "href", "replace", "scroll", "shallow", "prefetch", "locale"])),
      _excluded2 = (/* unused pure expression or super */ null && (["href", "activeClassName", "as", "className", "isMuiStyle", "role", "children"]));

function CustomLink_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CustomLink_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CustomLink_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CustomLink_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






 // Add support for the sx prop for consistency with the other branches.


const Anchor = (0,styled/* default */.ZP)('a')({});
const NextLinkComposed = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef((props, ref) => {
  const {
    to,
    linkAs,
    href,
    replace,
    scroll,
    shallow,
    prefetch,
    locale
  } = props,
        other = _objectWithoutProperties(props, _excluded);

  return _jsx(NextLink, {
    href: to,
    prefetch: prefetch,
    as: linkAs,
    replace: replace,
    scroll: scroll,
    shallow: shallow,
    passHref: true,
    locale: locale,
    children: _jsx(Anchor, CustomLink_objectSpread({
      ref: ref
    }, other))
  });
})));
// A styled version of the Next.js Link component:
// https://nextjs.org/docs/#with-link
const CustomLink_CustomLink = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef((props, ref) => {
  const {
    href,
    activeClassName = 'active',
    as: linkAs,
    className: classNameProps,
    isMuiStyle = true,
    role,
    // Link don't have roles.
    children
  } = props,
        other = _objectWithoutProperties(props, _excluded2);

  const router = useRouter();
  const pathname = typeof href === 'string' ? href : href.pathname;
  const className = clsx(classNameProps, {
    [activeClassName]: router.pathname === pathname && activeClassName
  });
  const isExternal = typeof href === 'string' && (href.startsWith('http') || href.startsWith('mailto:'));

  if (isExternal) {
    // 외부 사이트로 이동
    return isMuiStyle ? _jsx(MuiLink, CustomLink_objectSpread(CustomLink_objectSpread({
      className: className,
      href: href,
      ref: ref
    }, other), {}, {
      children: children
    })) : _jsx(Anchor, CustomLink_objectSpread(CustomLink_objectSpread({
      className: className,
      href: href,
      ref: ref
    }, other), {}, {
      children: children
    }));
  } else {
    return isMuiStyle ? _jsx(MuiLink, CustomLink_objectSpread(CustomLink_objectSpread({
      component: NextLinkComposed,
      linkAs: linkAs,
      className: className,
      ref: ref,
      to: href
    }, other), {}, {
      children: children
    })) : _jsx(NextLinkComposed, CustomLink_objectSpread(CustomLink_objectSpread({
      className: className,
      ref: ref,
      to: href
    }, other), {}, {
      children: children
    }));
  }
})));
;// CONCATENATED MODULE: ./components/base/Footer.tsx
function Footer_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









const EMAIL_ADDRESS = 'contact@legalengine.co.kr'; // e.g., © 2019, Jane Doe. All rights reserved.

const url = 'https://legalengine.co.kr/';
const Footer_name = 'Carillon Inc';

var _ref13 =  true ? {
  name: "g65o95",
  styles: "text-decoration:none"
} : 0;

const Copyright = () => {
  return _jsxs(Typography, {
    textAlign: "start",
    variant: "body2",
    color: "text.secondary",
    align: "center",
    children: ["\xA9 ".concat(new Date().getFullYear(), ", "), _jsx(CustomLink, {
      color: "inherit",
      href: url,
      css: _ref13,
      children: Footer_name
    }), '. All rights reserved.']
  });
};

var Footer_ref =  true ? {
  name: "142kyoc",
  styles: "padding-top:1.7rem"
} : 0;

var Footer_ref2 =  true ? {
  name: "14qjtrq",
  styles: "font-size:0.8rem;color:inherit;text-decoration:none"
} : 0;

var Footer_ref3 =  true ? {
  name: "bt6qrx",
  styles: "text-align:center;padding-top:1.7rem"
} : 0;

var Footer_ref4 =  true ? {
  name: "1ep9nyp",
  styles: "margin:0!important"
} : 0;

var Footer_ref5 =  true ? {
  name: "1rx9sa2",
  styles: "display:flex;flex-flow:row wrap;align-items:center;justify-content:space-between;margin:0 auto;width:90%;a{margin:0 auto;text-align:center;flex:0 0 50%;width:50%;text-decoration:none;color:#424242;&:hover{font-weight:500;}}"
} : 0;

var Footer_ref6 =  true ? {
  name: "ctl4wh",
  styles: "display:flex;flex-direction:column;justify-content:center;color:#424242;font-size:14px;font-weight:400"
} : 0;

var _ref7 =  true ? {
  name: "gwn0uu",
  styles: "background-color:#f8f9fa;overflow:hidden;padding:2rem 0;line-height:165%"
} : 0;

var _ref8 =  true ? {
  name: "1gy0n6m",
  styles: "display:flex;flex-direction:column;a{text-decoration:none;color:#424242;&:hover{font-weight:500;}}"
} : 0;

var _ref9 =  true ? {
  name: "8lzpky",
  styles: "border-right:0.5px solid #424242;margin:0 2rem"
} : 0;

var _ref10 =  true ? {
  name: "14qjtrq",
  styles: "font-size:0.8rem;color:inherit;text-decoration:none"
} : 0;

var _ref11 =  true ? {
  name: "fwyu67",
  styles: "display:flex;flex-direction:row;justify-content:center;color:#424242;font-size:14px;font-weight:400"
} : 0;

var _ref12 =  true ? {
  name: "gwn0uu",
  styles: "background-color:#f8f9fa;overflow:hidden;padding:2rem 0;line-height:165%"
} : 0;

const Footer = () => {
  const {
    width
  } = WindowDimension();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: width > 993 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("footer", {
      css: _ref12,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: _ref11,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: "\uC8FC\uC2DD\uD68C\uC0AC \uAE4C\uB9AC\uC6A9 \xA9 2019 Carillon Inc., All rights reserved."
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: "\uB300\uD45C: \uC624\uACBD\uC6D0 | \uC8FC\uC18C: \uC11C\uC6B8\uC2DC \uAC15\uB0A8\uAD6C \uD14C\uD5E4\uB780\uB85C 503, 1207\uD638"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: "\uC0AC\uC5C5\uC790 \uB4F1\uB85D\uBC88\uD638: 257-81-01787"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: "\uD1B5\uC2E0\uD310\uB9E4\uC5C5 \uC2E0\uACE0\uBC88\uD638: \uC81C 2021-\uC11C\uC6B8\uAC15\uB0A8-03354\uD638"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "mailto:".concat(EMAIL_ADDRESS),
            css: _ref10,
            children: "\uC774\uBA54\uC77C: ".concat(EMAIL_ADDRESS)
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: _ref9
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: _ref8,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "https://legalengine.co.kr/search?q=\uBB34\uC8C4&p=1&level1_case=\uC804\uBB38%20\uD310\uB840&level0=\uD310\uB840&bub_nm_category=\uC11C\uC6B8\uACE0\uB4F1\uBC95\uC6D0",
            target: "_blank",
            rel: "noreferrer",
            children: "\uD310\uB840\uAC80\uC0C9"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "https://legalengine.co.kr/termsofservice",
            target: "_blank",
            rel: "noreferrer",
            children: "\uC774\uC6A9\uC57D\uAD00"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "https://legalengine.co.kr/privacypolicy",
            target: "_blank",
            rel: "noreferrer",
            children: "\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC\uBC29\uCE68"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "https://legalengine.co.kr/update",
            target: "_blank",
            rel: "noreferrer",
            children: "\uC5C5\uB370\uC774\uD2B8"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "https://legalengine.co.kr/aboutus",
            target: "_blank",
            rel: "noreferrer",
            children: "\uD68C\uC0AC\uC18C\uAC1C"
          })]
        })]
      })
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("footer", {
      css: _ref7,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: Footer_ref6,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: Footer_ref5,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "https://legalengine.co.kr/termsofservice",
            target: "_blank",
            rel: "noreferrer",
            children: "\uC774\uC6A9\uC57D\uAD00"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "https://legalengine.co.kr/privacypolicy",
            target: "_blank",
            rel: "noreferrer",
            children: "\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC\uBC29\uCE68"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "https://legalengine.co.kr/update",
            target: "_blank",
            rel: "noreferrer",
            children: "\uC5C5\uB370\uC774\uD2B8"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "https://legalengine.co.kr/aboutus",
            target: "_blank",
            rel: "noreferrer",
            children: "\uD68C\uC0AC\uC18C\uAC1C"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "https://legalengine.co.kr/search?q=\uBB34\uC8C4&p=1&level1_case=\uC804\uBB38%20\uD310\uB840&level0=\uD310\uB840&bub_nm_category=\uC11C\uC6B8\uACE0\uB4F1\uBC95\uC6D0",
            target: "_blank",
            rel: "noreferrer",
            css: Footer_ref4,
            children: "\uD310\uB840\uAC80\uC0C9"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: Footer_ref3,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: "\uC8FC\uC2DD\uD68C\uC0AC \uAE4C\uB9AC\uC6A9 | \uB300\uD45C: \uC624\uACBD\uC6D0"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: "\uC8FC\uC18C: \uC11C\uC6B8\uC2DC \uAC15\uB0A8\uAD6C \uD14C\uD5E4\uB780\uB85C 503, 1207\uD638"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: "\uC0AC\uC5C5\uC790 \uB4F1\uB85D\uBC88\uD638: 257-81-01787"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: "\uD1B5\uC2E0\uD310\uB9E4\uC5C5 \uC2E0\uACE0\uBC88\uD638: \uC81C 2021-\uC11C\uC6B8\uAC15\uB0A8-03354\uD638"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "mailto:".concat(EMAIL_ADDRESS),
            css: Footer_ref2,
            children: "\uC774\uBA54\uC77C: ".concat(EMAIL_ADDRESS)
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: Footer_ref,
            children: "\xA9 2019 Carillon Inc., All rights reserved."
          })]
        })]
      })
    })
  });
};
// EXTERNAL MODULE: ./context/AuthContext.tsx
var AuthContext = __webpack_require__(1727);
;// CONCATENATED MODULE: ./components/base/header/Hamburger.tsx
function Hamburger_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Hamburger_ref =  true ? {
  name: "9vturt",
  styles: "width:20px;height:2px;border-radius:15px;position:relative;transform-origin:0.5px;background-color:#4c4c4c"
} : 0;

var Hamburger_ref2 =  true ? {
  name: "9vturt",
  styles: "width:20px;height:2px;border-radius:15px;position:relative;transform-origin:0.5px;background-color:#4c4c4c"
} : 0;

var Hamburger_ref3 =  true ? {
  name: "9vturt",
  styles: "width:20px;height:2px;border-radius:15px;position:relative;transform-origin:0.5px;background-color:#4c4c4c"
} : 0;

var Hamburger_ref4 =  true ? {
  name: "9v8np",
  styles: "display:none;@media (max-width: 992px){position:absolute;top:10px;right:10px;display:flex;flex-direction:column;justify-content:space-around;width:30px;height:20px;border:none;cursor:pointer;z-index:9000;}&:focus{outline:none;}"
} : 0;

var Hamburger_ref5 =  true ? {
  name: "160hmx6",
  styles: "display:none;@media (max-width: 992px){display:block;}"
} : 0;

const Hamburger = ({
  open,
  setOpen
}) => {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: Hamburger_ref5,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: Hamburger_ref4,
      onClick: () => setOpen(!open),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: Hamburger_ref3,
        style: {
          transform: open ? 'rotate(45deg)' : 'rotate(0)',
          top: open ? '3px' : '0'
        }
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: Hamburger_ref2,
        style: {
          opacity: open ? '0' : '1',
          top: open ? '0' : '0'
        }
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: Hamburger_ref,
        style: {
          transform: open ? 'rotate(-45deg)' : 'rotate(0)',
          top: open ? '3px' : '0'
        }
      })]
    })
  });
};
;// CONCATENATED MODULE: ./components/base/header/Menu.tsx
function Menu_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





const baseUrl = 'https://legalengine.co.kr';

var Menu_ref =  true ? {
  name: "1aln78i",
  styles: "@media (max-width: 992px){padding:0.5rem 0 0.5rem 2rem;color:#424242;text-align:left;}"
} : 0;

var Menu_ref2 =  true ? {
  name: "1aln78i",
  styles: "@media (max-width: 992px){padding:0.5rem 0 0.5rem 2rem;color:#424242;text-align:left;}"
} : 0;

var Menu_ref3 =  true ? {
  name: "ebko40",
  styles: "position:relative;bottom:10px;align-self:center;font-size:12px;color:rgb(229, 25, 42);font-weight:600;padding-right:0.5rem"
} : 0;

var Menu_ref4 =  true ? {
  name: "14e9qlv",
  styles: "@media (max-width: 992px){padding:0.5rem 0 0.5rem 2rem;color:#424242;text-align:left;padding-right:0.2rem;}"
} : 0;

var Menu_ref5 =  true ? {
  name: "avygqk",
  styles: "display:flex;flex-flow:row nowrap;justify-items:center;align-self:center"
} : 0;

var Menu_ref6 =  true ? {
  name: "8d9h2b",
  styles: "@media (max-width: 992px){position:relative;top:50px;font-size:18px;line-height:40px;font-weight:500;border-top:0.5px solid #c4c4c4;padding:1rem 0 1rem 0;a{text-decoration:none;}}"
} : 0;

var Menu_ref7 =  true ? {
  name: "oqv0qq",
  styles: "@media (max-width: 992px){width:50vw;position:relative;line-height:55px;background-color:white;color:#424242;border-left:0.5px solid #c4c4c4;}"
} : 0;

var Menu_ref8 =  true ? {
  name: "1nzjaj2",
  styles: "@media (max-width: 992px){width:50vw;position:relative;line-height:55px;background-color:white;color:#424242;}"
} : 0;

var Menu_ref9 =  true ? {
  name: "1di5pjx",
  styles: "@media (max-width: 992px){position:relative;display:flex;top:50px;font-size:18px;line-height:26px;font-weight:500;text-align:center;width:100%;height:55px;border-top:0.5px solid #c4c4c4;a{text-decoration:none;}}"
} : 0;

var Menu_ref10 =  true ? {
  name: "rg1juw",
  styles: "@media (max-width: 992px){position:fixed;background-color:white;top:0;bottom:0;right:0;left:0;z-index:2000;}"
} : 0;

var Menu_ref11 =  true ? {
  name: "160hmx6",
  styles: "display:none;@media (max-width: 992px){display:block;}"
} : 0;

var Menu_ref12 =  true ? {
  name: "6l3etq",
  styles: "@media (max-width: 992px){border:none;background-color:white;padding:0.5rem 0 0.5rem 2rem;color:#424242;font-weight:500;}"
} : 0;

var Menu_ref13 =  true ? {
  name: "l08t5z",
  styles: "@media (max-width: 992px){text-align:left;text-decoration:none;}"
} : 0;

var _ref14 =  true ? {
  name: "1f6zwjy",
  styles: "@media (max-width: 992px){position:relative;top:50px;font-size:18px;line-height:40px;border-top:0.5px solid #c4c4c4;padding:1rem 0 1rem 0;}"
} : 0;

const Menu = ({
  open,
  isAuthenticated
}) => {
  const {
    0: tabNames,
    1: setTabNames
  } = (0,react.useState)({
    info: '회원 정보',
    requestcase: '내가 요청한 판례',
    bookmark: '북마크',
    highlight: '하이라이트',
    history: '히스토리'
  });

  const RenderIsAuth = () => {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: _ref14,
      children: Object.entries(tabNames).map((e, idx) => {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          css: Menu_ref13,
          href: "".concat(baseUrl, "/user/profile/").concat(e[0]),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: Menu_ref12,
            children: e[1]
          })
        }, e[0]);
      })
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: Menu_ref11,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: Menu_ref10,
      style: {
        display: open ? 'block' : 'none'
      },
      children: [isAuthenticated ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RenderIsAuth, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: Menu_ref9,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          href: "".concat(baseUrl, "/user/login"),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: Menu_ref8,
            children: "\uB85C\uADF8\uC778"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          href: "".concat(baseUrl, "/user/signup"),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: Menu_ref7,
            children: "\uD68C\uC6D0\uAC00\uC785"
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: Menu_ref6,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
          css: Menu_ref5,
          href: "/crimesearch",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: Menu_ref4,
            children: "\uBB34\uC8C4\uD310\uACB0 \uAC80\uC0C9"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: Menu_ref3,
            children: "new"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          href: "".concat(baseUrl, "/posts"),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: Menu_ref2,
            children: "\uD3EC\uC2A4\uD2B8"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          href: "".concat(baseUrl, "/translator"),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: Menu_ref,
            children: "\uBC95\uB960 \uBC88\uC5ED"
          })
        })]
      })]
    })
  });
};
;// CONCATENATED MODULE: ./components/base/header/Header.tsx
function Header_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









const Header_baseUrl = 'https://legalengine.co.kr';

var Header_ref =  true ? {
  name: "13bo0lq",
  styles: "border-radius:15px;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0.2rem 0.6rem 0.3rem 0.6rem;cursor:pointer;font-weight:500;font-size:1rem;line-height:23px;margin-right:1.4rem;text-align:center;color:white;background-color:#002366;&:hover{text-decoration:none;font-weight:600;}"
} : 0;

var Header_ref2 =  true ? {
  name: "i7jftr",
  styles: "border-radius:15px;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0.2rem 0.6rem 0.3rem 0.6rem;cursor:pointer;font-weight:500;font-size:1rem;line-height:23px;margin-right:1.4rem;text-align:center;color:#002366;border:1px solid #002366;&:hover{text-decoration:none;font-weight:600;}"
} : 0;

var Header_ref3 =  true ? {
  name: "i7jftr",
  styles: "border-radius:15px;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0.2rem 0.6rem 0.3rem 0.6rem;cursor:pointer;font-weight:500;font-size:1rem;line-height:23px;margin-right:1.4rem;text-align:center;color:#002366;border:1px solid #002366;&:hover{text-decoration:none;font-weight:600;}"
} : 0;

var Header_ref4 =  true ? {
  name: "ftavjv",
  styles: "font-weight:500;font-size:1rem;line-height:23px;text-align:center;cursor:pointer;color:black;padding-top:5px;padding-right:1.3rem;&:hover{text-decoration:none;font-weight:600;}"
} : 0;

var Header_ref5 =  true ? {
  name: "ftavjv",
  styles: "font-weight:500;font-size:1rem;line-height:23px;text-align:center;cursor:pointer;color:black;padding-top:5px;padding-right:1.3rem;&:hover{text-decoration:none;font-weight:600;}"
} : 0;

var Header_ref6 =  true ? {
  name: "ebko40",
  styles: "position:relative;bottom:10px;align-self:center;font-size:12px;color:rgb(229, 25, 42);font-weight:600;padding-right:0.5rem"
} : 0;

var Header_ref7 =  true ? {
  name: "1cht6yu",
  styles: "font-weight:500;font-size:1rem;line-height:23px;text-align:center;cursor:pointer;color:black;padding-right:0.2rem;&:hover{text-decoration:none;font-weight:600;}"
} : 0;

var Header_ref8 =  true ? {
  name: "avygqk",
  styles: "display:flex;flex-flow:row nowrap;justify-items:center;align-self:center"
} : 0;

var Header_ref9 =  true ? {
  name: "15ml0cf",
  styles: "display:flex;display:-ms-flexbox;justify-items:center;align-self:center;a{text-decoration:none;}@media (max-width: 992px){display:none;}"
} : 0;

var Header_ref10 =  true ? {
  name: "s7lnbf",
  styles: "flex:1;align-self:center"
} : 0;

var Header_ref11 =  true ? {
  name: "oolohh",
  styles: "display:inline-block;padding-top:16px;vertical-align:top;font-size:12px;color:rgb(229, 25, 42);font-weight:600;@media (max-width: 992px){padding-top:0;}"
} : 0;

var Header_ref12 =  true ? {
  name: "o2gycr",
  styles: "width:12rem;margin-left:1.5rem;margin-top:0.5rem;height:55px;cursor:pointer;@media (max-width: 992px){width:120px;margin-top:10px;height:25px;cursor:pointer;}"
} : 0;

var Header_ref13 =  true ? {
  name: "n27l8s",
  styles: "@media (max-width: 992px){text-align:center;}"
} : 0;

var Header_ref14 =  true ? {
  name: "13ke12u",
  styles: "position:fixed;top:0;left:0;width:100%;display:flex;display:-ms-flexbox;height:65px;border-bottom:0.5px solid #d1d1d1;background-color:white;z-index:1030;@media (max-width: 992px){display:block;height:40px;text-align:center;}"
} : 0;

const StandardHeader = () => {
  const {
    0: open,
    1: setOpen
  } = (0,react.useState)(false);
  const {
    user
  } = (0,AuthContext/* useAuth */.aC)();
  const {
    0: isAuthenticated,
    1: setIsAuthenticated
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    setIsAuthenticated(!!user);
  }, [user]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("header", {
    css: Header_ref14,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: Header_ref13,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: "".concat(Header_baseUrl),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          css: Header_ref12,
          src: '/logo/logo.svg',
          alt: 'Legal Engine'
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: Header_ref11,
        children: "beta"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("nav", {
      css: Header_ref10
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("nav", {
      css: Header_ref9,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
        css: Header_ref8,
        href: "/crimesearch",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: Header_ref7,
          children: "\uBB34\uC8C4\uD310\uACB0 \uAC80\uC0C9"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: Header_ref6,
          children: "new"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: "".concat(Header_baseUrl, "/posts"),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: Header_ref5,
          children: "\uD3EC\uC2A4\uD2B8"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: "".concat(Header_baseUrl, "/translator"),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: Header_ref4,
          children: "\uBC95\uB960 \uBC88\uC5ED"
        })
      }), isAuthenticated ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: "".concat(Header_baseUrl, "/user/profile/info"),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: Header_ref3,
          children: "\uD504\uB85C\uD544"
        })
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          href: "".concat(Header_baseUrl, "/user/login"),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: Header_ref2,
            children: "\uB85C\uADF8\uC778"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          href: "".concat(Header_baseUrl, "/user/signup"),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: Header_ref,
            children: "\uD68C\uC6D0\uAC00\uC785"
          })
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hamburger, {
      open: open,
      setOpen: setOpen
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, {
      open: open,
      isAuthenticated: isAuthenticated
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
;// CONCATENATED MODULE: ./components/base/PageHead.tsx




const PageHead = ({
  title = "AI 무죄 판례 검색 | AI 판례 검색, 리걸 리서치",
  description = "이제 무죄 판결문 찾아 헤매지 마세요. 문제 상황만 알려주시면 리걸엔진이 찾아드립니다.",
  keywords = "판례 검색, 판결문 검색, 리걸 리서치, 리걸테크, 리걸AI, 법률 번역"
}) => {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(head["default"], {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "title",
      content: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "description",
      content: description
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "keywords",
      content: keywords
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      property: "og:type",
      content: "website"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "og:title",
      property: "og:title",
      content: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "og:description",
      property: "og:description",
      content: description
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      property: "og:url",
      content: "https://ai.legalengine.co.kr/crimesearch"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      property: "og:image",
      content: "/logo/meta_img.png"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "twitter:card",
      content: "summary"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "twitter:title",
      content: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "twitter:description",
      content: description
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "twitter:creator",
      content: "\uB9AC\uAC78\uC5D4\uC9C4"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "twitter:image",
      content: "/logo/meta_img.png"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "shortcut icon",
      href: "/favicon.ico"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "icon",
      type: "image/png",
      href: "/favicon.ico"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "apple-touch-icon",
      href: "/favicon.ico"
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Box/Box.js + 2 modules
var Box = __webpack_require__(9517);
;// CONCATENATED MODULE: ./components/base/ToolbarPadder.tsx


function ToolbarPadder_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ToolbarPadder_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ToolbarPadder_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ToolbarPadder_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





const CustomToolbar = (0,styled/* default */.ZP)(Box/* default */.Z)(({
  theme
}) => ToolbarPadder_objectSpread({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  // background: 'red',
  padding: theme.spacing(0, 1)
}, theme.mixins.toolbar)); // mui 툴바 이용시 툴바 사이즈와 동일한 패딩이 필요한 경우 사용. 툴바 기본 설정 변경시 툴바 패더의 기본설정이 함께 변동되므로 높이 조절에 신경쓰지 않아도 됨

const ToolbarPadder = () => {
  // return <Toolbar aria-label='padder' />;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomToolbar, {
    "aria-label": "padder"
  });
};
;// CONCATENATED MODULE: ./components/layout/MainLayout.tsx









const MainLayout = ({
  title,
  showSearchBar,
  value,
  onChange,
  placeholder,
  onToggleDrawer,
  anchor,
  drawerWidth,
  drawerWidthWhenPermanent,
  children
}) => {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageHead, {
      title: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardHeader, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
      component: "main",
      sx: {
        flexGrow: 1,
        width: {
          sm: "calc(100% - ".concat(drawerWidth, "px)")
        }
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarPadder, {}), children]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, {})]
  });
};
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 6 modules
var CircularProgress = __webpack_require__(6052);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./pages/crimesearch/index.tsx
function crimesearch_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var crimesearch_ref =  true ? {
  name: "mz39l5",
  styles: "max-width:80%;min-height:calc(100vh - 64px);display:flex;flex-flow:column nowrap;justify-content:flex-start;align-items:center;margin:2rem auto;gap:2rem;@media (max-width: 992px){max-width:90%;}"
} : 0;

var crimesearch_ref2 =  true ? {
  name: "vg01tj",
  styles: "max-width:80%;min-height:calc(100vh - 64px);display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;margin:auto;@media (max-width: 992px){max-width:90%;}"
} : 0;

function CrimePage() {
  const router = (0,next_router.useRouter)();
  const {
    user
  } = (0,AuthContext/* useAuth */.aC)();
  const {
    0: queryText,
    1: setQueryText
  } = (0,react.useState)('');
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react.useState)(false);
  const {
    0: email,
    1: setEmail
  } = (0,react.useState)('');
  const {
    0: data,
    1: setData
  } = (0,react.useState)({
    id: '',
    input: '',
    output: []
  });
  (0,react.useEffect)(() => {
    setEmail(user === null || user === void 0 ? void 0 : user.email);
  }, [user]);
  (0,react.useEffect)(() => {
    let routerId = router.query.id;

    if (routerId === undefined) {
      routerId = '';
    } else if (Array.isArray(routerId)) {
      routerId = '';
    }

    const id = routerId;
    getCrimeData(id);
  }, [router.query]);

  const getCrimeData = async id => {
    if (!id) return;
    const baseUrl = "https://api2.legalengine.co.kr";

    try {
      setIsLoading(true);
      const res = await axios_default().get("".concat(baseUrl, "/api/crime/").concat(id));
      const data = res.data;
      setData(data);
      setQueryText(data.input);
      setIsLoading(false);
    } catch (error) {
      console.log('error', error);
    }
  };

  const postQuery = async query => {
    if (!query) return;
    const baseUrl = "https://api2.legalengine.co.kr";

    try {
      const payload = {
        q: query
      };
      const res = await axios_default().post("".concat(baseUrl, "/api/crime"), payload);
      const id = res.data.id;
      return id;
    } catch (error) {
      console.log('error', error);
    }
  };

  const onClickSearch = ev => {
    if (queryText) {
      onSearch(queryText);
    }
  };

  const onSearch = async queryText => {
    const id = await postQuery(queryText);
    const sliceQuery = queryText.slice(0, 50);
    const queryString = "/crimesearch?id=".concat(id, "#").concat(sliceQuery);
    router.push(queryString, undefined, {
      shallow: true
    });
  };

  const placeholder = '[예시] 2021년 12월 25일 강원 인제군 출렁다리 앞 도로에서 술에 취한 상태로 화물차를 운전하였다.';
  const mobileCss = "width: 100%; font-size:16px;";
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: isLoading ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
      css: crimesearch_ref2,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircularProgress/* default */.Z, {})
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
      css: crimesearch_ref,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("font-size:22px;font-weight:700;color:#002366;justify-items:flex-start;border-bottom:2px solid #002366;padding-bottom:1rem;width:80%;@media (max-width: 992px){", mobileCss, " font-size:18px;}" + ( true ? "" : 0),  true ? "" : 0),
        children: "\uBB34\uC8C4 \uD310\uACB0\uBB38\uC744 \uCC3E\uC544\uC8FC\uB294 \uB9AC\uAC78\uC5D4\uC9C4"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CrimeSearchBar, {
        placeholder: placeholder,
        queryText: queryText,
        setQueryText: setQueryText
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("width:19rem;height:3rem;color:#ffffff;background-color:#002366;border-radius:5px;font-size:20px;font-weight:700;cursor:pointer;@media (max-width: 992px){", mobileCss, ";}" + ( true ? "" : 0),  true ? "" : 0),
        onClick: onClickSearch,
        children: "\uAC80\uC0C9\uD558\uAE30"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CrimeResult, {
        userEmail: email,
        data: data
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CaseLists, {
        data: data
      })]
    })
  });
}

CrimePage.getLayout = page => {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainLayout, {
    children: page
  });
};

/***/ }),

/***/ 6283:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crimesearch",
      function () {
        return __webpack_require__(1743);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [597,774,888,179], function() { return __webpack_exec__(6283); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);